<div class="p-5 grid grid-cols-4 items-center gap-2" [formGroup]="platformLicensePricingForm">
    <span class="label-text" i18n>Internal Description</span>
    <div class="col-span-3 flex flex-col items-stretch gap-1">
        <input
            class="input input-sm input-bordered"
            formControlName="internalDescription"
            i18n-placeholder
            placeholder="INH Summer Discount 2024"
        />
    </div>

    <ng-container *ngIf="shouldPriceMonthlyAndYearlyBeVisible">
        <span class="self-start pt-[6px] label-text" i18n>Price monthly</span>
        <div class="self-start flex flex-col items-stretch gap-1">
            <label class="w-full input-group input-group-sm">
                <input
                    class="min-w-0 flex-1 input input-sm input-bordered"
                    type="number"
                    formControlName="licensePriceMonthly"
                    [ngClass]="{ 'border-error': platformLicensePricingForm.get('licensePriceMonthly').invalid }"
                />
                <span>€</span>
            </label>
            <span
                class="text-xs text-error"
                *ngIf="
                    platformLicensePricingForm.get('licensePriceMonthly').dirty &&
                    platformLicensePricingForm.get('licensePriceMonthly').invalid
                "
                i18n
                >The monthly price is required.</span
            >
        </div>

        <span class="self-start pt-[6px] justify-self-end label-text" i18n>Price yearly</span>
        <div class="self-start flex flex-col items-stretch gap-1">
            <label class="w-full input-group input-group-sm">
                <input
                    class="min-w-0 flex-1 input input-sm input-bordered"
                    type="number"
                    formControlName="licensePriceYearly"
                    [ngClass]="{ 'border-error': platformLicensePricingForm.get('licensePriceYearly').invalid }"
                />
                <span>€</span>
            </label>
            <span
                class="text-xs text-error"
                *ngIf="
                    platformLicensePricingForm.get('licensePriceYearly').dirty &&
                    platformLicensePricingForm.get('licensePriceYearly').invalid
                "
                i18n
                >The yearly price is required.</span
            >
        </div>
    </ng-container>

    <span class="label-text" i18n>Sales tax</span>
    <div class="col-span-3 flex flex-col items-stretch gap-1">
        <label class="input-group input-group-sm">
            <input
                type="number"
                min="0"
                max="1"
                step="0.01"
                placeholder="0.19"
                class="flex-1 min-w-0 input input-sm input-bordered"
                formControlName="licenseSalesTax"
                [ngClass]="{ 'border-error': platformLicensePricingForm.get('licenseSalesTax').invalid }"
            />
            <span>%</span>
        </label>
        <span
            class="text-xs text-error"
            *ngIf="platformLicensePricingForm.get('licenseSalesTax').dirty && platformLicensePricingForm.get('licenseSalesTax').invalid"
            i18n
            >The sales tax is mandatory and the value must be between 0 and 1</span
        >
    </div>

    <ng-container *ngIf="shouldPriceIntervalsBeVisible">
        <div class="col-span-4 divider" i18n>Price intervals per user</div>

        <div class="col-span-4 flex flex-row gap-4">
            <div class="flex-1 col-span-4 grid grid-cols-4 gap-2">
                <span class="label-text" i18n>Interval begin</span>
                <span class="label-text" i18n>Interval end</span>
                <span class="label-text" i18n>Monthly price</span>
                <span class="label-text" i18n>Yearly price</span>
            </div>
            <div class="w-10"></div>
        </div>

        <ng-container formArrayName="priceIntervalsPerUser">
            <div class="col-span-4 flex flex-col items-stretch gap-2">
                <ng-container *ngFor="let priceIntervalForm of priceIntervalsPerUser.controls; let i = index">
                    <div class="flex flex-row gap-4" [formGroup]="priceIntervalForm">
                        <div class="flex-1 grid grid-cols-4 gap-2">
                            <div class="flex flex-col items-stretch gap-1">
                                <input
                                    class="input input-sm input-bordered"
                                    type="number"
                                    formControlName="minNumberOfEmployees"
                                    [ngClass]="{ 'border-error': priceIntervalForm.get('minNumberOfEmployees').invalid }"
                                />
                                <span
                                    class="text-xs text-error"
                                    *ngIf="
                                        priceIntervalForm.get('minNumberOfEmployees').dirty &&
                                        priceIntervalForm.get('minNumberOfEmployees').invalid
                                    "
                                    i18n
                                    >The Interval begin is required.</span
                                >
                                <div *ngIf="priceIntervalForm?.errors?.beginGreaterThanEnd">
                                    <span class="text-error text-sm" i18n>The Interval begin must be smaller than the end</span>
                                </div>
                            </div>
                            <div class="flex flex-col items-stretch gap-1">
                                <input
                                    class="input input-sm input-bordered"
                                    type="number"
                                    formControlName="maxNumberOfEmployees"
                                    [ngClass]="{ 'border-error': priceIntervalForm.get('maxNumberOfEmployees').invalid }"
                                />
                                <span
                                    class="text-xs text-error"
                                    *ngIf="
                                        priceIntervalForm.get('maxNumberOfEmployees').dirty &&
                                        priceIntervalForm.get('maxNumberOfEmployees').invalid
                                    "
                                    i18n
                                    >The Interval end is required.</span
                                >
                            </div>
                            <div class="flex flex-col items-stretch gap-1">
                                <label class="w-full input-group input-group-sm">
                                    <input
                                        class="min-w-0 flex-1 input input-sm input-bordered"
                                        type="number"
                                        formControlName="priceMonthly"
                                        [ngClass]="{ 'border-error': priceIntervalForm.get('priceMonthly').invalid }"
                                    />
                                    <span>€</span>
                                </label>
                                <span
                                    class="text-xs text-error"
                                    *ngIf="priceIntervalForm.get('priceMonthly').dirty && priceIntervalForm.get('priceMonthly').invalid"
                                    i18n
                                    >The monthly price is required.</span
                                >
                            </div>
                            <div class="flex flex-col items-stretch gap-1">
                                <label class="w-full input-group input-group-sm">
                                    <input
                                        class="min-w-0 flex-1 input input-sm input-bordered"
                                        type="number"
                                        formControlName="priceYearly"
                                        [ngClass]="{ 'border-error': priceIntervalForm.get('priceYearly').invalid }"
                                    />
                                    <span>€</span>
                                </label>
                                <span
                                    class="text-xs text-error"
                                    *ngIf="priceIntervalForm.get('priceYearly').dirty && priceIntervalForm.get('priceYearly').invalid"
                                    i18n
                                    >The yearly price is required.</span
                                >
                            </div>
                        </div>
                        <div class="w-10">
                            <button
                                *ngIf="editMode"
                                i18n-matTooltip
                                matTooltip="Remove price interval"
                                matTooltipClass="bg-iota-tooltip-bg"
                                class="top-[6px] self-start btn btn-ghost btn-circle btn-sm"
                                (click)="removePriceInterval(i)"
                            >
                                <iota-icon icon="trash"></iota-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>

                <div *ngIf="!priceIntervalsPerUser?.controls?.length" class="text-center text-sm italic" i18n>
                    No price intervals defined.
                </div>

                <div *ngIf="platformLicensePricingForm?.errors?.priceIntervalsIntersect" class="text-center text-error" i18n>
                    Some price intervals overlap each other with the begin/end values.
                </div>
                <div *ngIf="platformLicensePricingForm?.errors?.priceIntervalsHaveGaps" class="text-center text-error" i18n>
                    There are gaps between some price intervals (end/begin)
                </div>

                <div class="flex flex-row items-center justify-center">
                    <button
                        *ngIf="editMode"
                        class="btn btn-primary btn-sm"
                        [disabled]="platformLicensePricingForm.disabled"
                        (click)="addPriceInterval(undefined, true)"
                        i18n
                    >
                        Add price interval
                    </button>
                </div>
            </div>
        </ng-container>
        <div class="col-span-4 divider"></div>
    </ng-container>

    <div class="flex flex-row items-center gap-2">
        <span class="label-text" i18n>Price effective from</span>
        <div class="tooltip" data-tip="Optional dates from/to when the license is effective" i18n-data-tip>
            <iota-icon icon="question-mark-circle" class="text-white fill-white"></iota-icon>
        </div>
    </div>
    <input class="input input-sm input-bordered" type="date" formControlName="effectiveFrom" />

    <label class="justify-self-center label-text" i18n>until</label>
    <input class="input input-sm input-bordered" type="date" formControlName="effectiveTo" />
</div>
